import { TypedEvent } from "@faro-lotv/foundation";

/** Emitted to bring the camera back to the default framing of the wizard */
export const recenterIpxViewEvent = new TypedEvent<void>();
